const menu = require('../../../../../components/menu/menu')

export function start(detail, htmlDt, htmlFc) {
  const menuElem = menuBody[detail.id]
  if (!menuElem) return

  menuElem.forEach(item => item.start(detail, htmlDt, htmlFc))
  detail.html = menuElem
  detail.act = 'show'
  menu.start(detail)
}

const menuBody = {
  fullcontOptions: [{
    text: '',
    svg: 'update',
    class: 'green',
    dataDetail: '',
    start: function () {
      this.text = 'Restore'
      this.dataDetail = `data-detail='{
        "click": [
          {"dest":"ripple"},
          {"dest":"menu", "act":"hide"},
          {"dest":"saleDeleted", "elem":"fullcont", "id":"saleDeleted-fullcont", "act":"restore"}
        ]
      }'`
    }
  }]
}

